import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";

let steps = [
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__requested_amount__",
        fields: [
            {
                // label: 'Desired Loan Amount',
                name: 'requested_amount',
                placeholder: '1000',
                // prependInputSpan: '$',
                // appendInputSpan: '.00',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_1000_less__", "value": "750"},
                    {"text": "__opt_amount_1001_2000__", "value": "1500"},
                    {"text": "__opt_amount_2001_5000__", "value": "3500"},
                    {"text": "__opt_5001_10000__", "value": "7500"},
                    {"text": "__opt_10001_15000__", "value": "15000"},
                    {"text": "__opt_15001_20000__", "value": "20000"},
                    {"text": "__opt_20000_more__", "value": "25000"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
        },
        title: "__product_purpose__",
        fields: [
            {
                // label: 'Loan Purpose',
                name: 'product_purpose',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_debt_consolidation__", "value": "Debt Consolidation"},
                    {"text": "__opt_cc_consolidation__", "value": "Credit Card Consolidation"},
                    {"text": "__opt_emergency_expense__", "value": "Emergency Expense"},
                    {"text": "__opt_car_repair__", "value": "Car Maintenance"},
                    {"text": "__opt_other__", "value": "Other"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    // STARTS: unsecured amount if purpose debt/credit card consolidation
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__cc_debt_amount__',
        fields: [
            {
                // label: 'Credit Card Debt Amount',
                name: 'cc_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_debt_amounts_2500_less__", "value":"2500" },
                    { "text":"__opt_debt_amounts_2501_5000__", "value":"5000" },
                    { "text":"__opt_debt_amounts_5001_10000__", "value":"7500" },
                    { "text":"__opt_debt_amounts_10001_15000__", "value":"10000" },
                    { "text":"__opt_debt_amounts_15001_20000__", "value":"15000" },
                    { "text":"__opt_debt_amounts_20001_25000__", "value":"20000" },
                    { "text":"__opt_debt_amounts_25000_more__", "value":"25000" },
                    { "text":"__opt_debt_no_cc_debt__", "value":"0" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'Debt Consolidation',
                'Credit Card Consolidation',
            ];
            return !app.product_purpose || !options.includes(app.product_purpose);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__unsecured_debt_amount__',
        textTop: '__unsecured_debt_amount_definition__',
        fields: [
            {
                // label: 'Total Other Unsecured Debt',
                name: 'unsecured_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: (app) => {
                    const defaultChoices = [
                        { "text": "__opt_debt_amounts_2500_less__", "value": "2500" },
                        { "text": "__opt_debt_amounts_2501_5000__", "value": "5000" },
                        { "text": "__opt_debt_amounts_5001_10000__", "value": "7500" },
                        { "text": "__opt_debt_amounts_10001_15000__", "value": "10000" },
                        { "text": "__opt_debt_amounts_15001_20000__", "value": "15000" },
                        { "text": "__opt_debt_amounts_20001_25000__", "value": "20000" },
                        { "text": "__opt_debt_amounts_25000_more__", "value": "25000" },
                    ];

                    return app.cc_debt_amount && app.cc_debt_amount > 0
                        ? [...defaultChoices, { "text": "__opt_debt_no_unsecured_debt__", "value": "0" }]
                        : defaultChoices;
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'Debt Consolidation',
                'Credit Card Consolidation',
            ];
            return !app.product_purpose || !options.includes(app.product_purpose);
        }
    },
    // ENDS: unsecured amount if purpose debt/credit card consolidation
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
        },
        title: "__in_credit_situation__",
        fields: [
            {
                // label: 'Loan Purpose',
                // name: 'credit_score',
                name: 'in_credit_situation',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    // {"text": "__opt_in_credit_situation_cp__", "value":"in_consumer_proposal"},
                    {"text": "__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__income_type__",
        fields: [
            {
                // label: 'Income Source',
                name: 'income_type',
                placeholder: '__income_type__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_income_type_employed__", "value":"full_time" },
                    { "text":"__opt_income_type_social_security__", "value":"social_security" },
                    { "text":"__opt_income_type_self__", "value":"self_employed" },
                    { "text":"__opt_income_type_unemployed__", "value":"unemployed" },
                    { "text":"__opt_other__", "value":"other" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__direct_deposit__",
        fields: [
            {
                // label: 'Do you receive your income by direct deposit?',
                name: 'direct_deposit',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
                // hideIfCondition: (app) => {
                //     return fieldConditionHelper.employment(app);
                // }
            },
        ],
        hideButtonsSection: true,
        // hideIfCondition: (app) => {
        //     return fieldConditionHelper.employment(app);
        // }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__monthly_income__",
        fields: [
            {
                // label: 'Monthly Income',
                name: 'monthly_income',
                placeholder: '2500',
                // prependInputSpan: '$',
                // appendInputSpan: '.00',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_1500_less__", "value":"1500" },
                    { "text":"__opt_1501_2000__", "value":"2000" },
                    { "text":"__opt_2001_3000__", "value":"3000" },
                    { "text":"__opt_3001_4000__", "value":"4000" },
                    { "text":"__opt_4001_5000__", "value":"5000" },
                    { "text":"__opt_5000_more__", "value":"5500" },
                ],
                attrs: {
                    maxlength: 5
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__address__",
        fields: [
            {
                // addressLabel: null,
                name: 'address',
                placeholder: '',
                type: 'fulladdress',
                fieldOuterClass: 'col-md-8 offset-md-2',
                value: null,
                // validationRules: 'required',
            },
        ],
    },
    {
        beforeCreate: function() {
        },
        beforeNextStep: function() {
        },
        title: "__address_length_months__",
        fields: [
            {
                // label: 'Time At Address',
                name: 'address_length_months',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_address_length_months_3_less__", "value":"2" },
                    { "text":"__opt_address_length_months_3_6__", "value":"6" },
                    { "text":"__opt_address_length_months_6_12__", "value":"12" },
                    { "text":"__opt_address_length_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        // beforeCreate: 'enablePartialRequestPerStep',
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__how_to_contact__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                // placeholder: 'First Name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                // placeholder: 'Last Name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__email_address__',
                name: 'email',
                // placeholder: '__your_email__',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                // placeholder: 'Your phone number',
                type: 'text',
                value: null,
                validationRules: 'required|usPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
                // textBottom: '__phone_number_sms_results__'
            },
            // {
            //     // label: 'Credit Auth',
            //     label: false,
            //     name: 'opt_in',
            //     placeholder: '',
            //     type: 'checkbox',
            //     value: null,
            //     // validationRules: 'required',
            //     // fieldOuterClass: 'col-md-10 offset-md-1',
            //     fieldInnerClass: 'large-checkbox',
            //     // choices: [
            //     //     { "text":'__opt_opt_in_consent__', "value":true },
            //     // ],
            //     choices: (app) => {
            //         return [
            //             { "text":`Receive promotions and updates from Rebound Finance by email. You can opt-out at any time. By clicking 'Next' you agree to the <a href="https://reboundfinance.com/terms/" target="_blank">terms of use</a> and <a href="https://reboundfinance.com/privacy-policy/" target="_blank">privacy policy`, "value":true },
            //         ];
            //     },
            // },
        ],
        textBottom: '__us_consent__',
        // textBottomBelowActionButtons: `<p class="text-center" style="font-size:13px; color:#aaa;">By clicking 'Next' you agree to the <a href="https://app.reboundfinance.com/terms/" target="_blank">terms of use</a> and <a href="https://app.reboundfinance.com/privacy-policy/" target="_blank">privacy policy</a> and to receive promotions and updates from Rebound Finance by email. You can opt-out at any time. Data may be stored outside of your state. Your data may be shared with Rebound Finance partners to qualify your request. You also authorize the provider(s) you're matched with to assess your credit history (this will not affect your credit score). Your data is never shared with third parties for marketing messaging purposes.</p>`
    },
    // {
    //     // beforeCreate: function() {},
    //     beforeCreate: 'enablePartialRequestPerStep',
    //     beforeNextStep: function() {},
    //     title: "__sms_verification__",
    //     fields: [
    //         {
    //             // label: 'SMS Verification',
    //             name: 'sms_verification',
    //             type: 'smsverification',
    //             value: null,
    //             hideSubtitles: true,
    //         },
    //     ],
    //     hideButtonsSection: true,
    //     nextButtonText: '__skip__',
    //     nextButtonClass: 'btn-secondary',
    //     hideIfCondition: (app) => {
    //         // enforce sms verification
    //         return false;
    //
    //         // let's sum cc_debt_amount & unsecured_debt_amount and hide this step if total is less then 10k
    //         let totalDebt = 0;
    //         if(app.cc_debt_amount) {
    //             totalDebt += parseInt(app.cc_debt_amount);
    //         }
    //         if(app.unsecured_debt_amount) {
    //             totalDebt += parseInt(app.unsecured_debt_amount);
    //         }
    //         if(totalDebt < 10000) {
    //             return true;
    //         }
    //
    //         return false;
    //     }
    // },
    {
        beforeCreate: 'enablePartialRequestPerStep',
        // beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__dob__",
        fields: [
            {
                // label: 'What is your date of birth?',
                name: 'dob',
                placeholder: null,
                type: 'date',
                value: null,
                validationRules: 'required|dob',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: true,
            },
        ],
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__employer_information__",
        // employment group questions
        fields: [
            {
                label: '__employer_name__',
                name: 'employer',
                placeholder: '',
                type: 'text',
                value: null,
                validationRules: 'required|max:50',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: true,
            },
            {
                label: '__job_title__',
                name: 'job_title',
                placeholder: '',
                type: 'text',
                value: null,
                validationRules: 'required|max:50',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: true,
            },
            // {
            //     label: '__phone_number_work__',
            //     name: 'phone_number_work',
            //     placeholder: '',
            //     type: 'text',
            //     value: null,
            //     validationRules: 'required|phone',
            //     fieldOuterClass: 'col-md-8 offset-md-2',
            //     attrs: {
            //         maxlength: 10
            //     },
            // },
        ],
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app) || (app.income_type && app.income_type == 'self_employed');
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__employed_months__",
        // employment group questions
        fields: [
            {
                // label: 'Time At Job',
                name: 'employed_months',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_employed_months_3_less__", "value":"2" },
                    { "text":"__opt_employed_months_3_6__", "value":"6" },
                    { "text":"__opt_employed_months_6_12__", "value":"12" },
                    { "text":"__opt_employed_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__pay_frequency__",
        // employment group questions
        fields: [
            {
                // label: 'Pay Frequency',
                name: 'pay_frequency',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_weekly__", "value":"WEEKLY" },
                    { "text":"__opt_bi_weekly__", "value":"BIWEEKLY" },
                    { "text":"__opt_semi_monthly__", "value":"TWICEMONTHLY" },
                    { "text":"__opt_monthly__", "value":"MONTHLY" },
                ],
                hideIfHasValue: true,
            }
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__pay_date1__",
        // employment group questions
        fields: [
            {
                // label: 'Next Pay Date',
                name: 'pay_date1',
                placeholder: null,
                type: 'date',
                value: null,
                validationRules: 'required|date|paydate',
                fieldOuterClass: 'col-md-6 offset-md-3',
                clearfixTop: true,
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: false,
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__ssn__",
        // employment group questions
        fields: [
            {
                // label: 'Next Pay Date',
                name: 'ssn',
                placeholder: null,
                type: 'text',
                value: null,
                validationRules: 'required|ssn',
                fieldOuterClass: 'col-md-6 offset-md-3',
                clearfixTop: true,
                attrs: {
                    maxlength: 9
                },
                hideIfHasValue: false,
            },
        ],
        hideButtonsSection: false,
    }
];

export default steps;
